import { Box, Button } from "rebass";

const ErrorPlaceholder = ({ errorCode, message, sub, icon, button }) => {
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          width: ["80%", "50%"],
          height: ["80%", "50%"],
          padding: ["10px", "20px"],
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          color: "GrayText",
          background: "rgba(249, 250, 251, 1)",
          gap: "15px",
        }}
      >
        {!!icon && icon}
        {!!errorCode && (
          <Box fontSize={"60px"} textAlign={["center", null]}>
            {errorCode}
          </Box>
        )}
        <Box
          fontSize={["22px", "28px"]}
          fontWeight={"bold"}
          textAlign={["center", null]}
        >
          {message}
        </Box>
        {sub && (
          <Box
            fontSize={["14px", "20px"]}
            fontWeight={"bold"}
            textAlign={["center", null]}
          >
            {sub}
          </Box>
        )}
        {!!button && (
          <Button
            {...button}
            sx={{
              "&:hover": {
                backgroundColor: "#909090",
                border: "1px solid #909090",
              },
              border: "1px solid #333",
              backgroundColor: "#333",
              ...button.sx,
            }}
          >
            {button.label}
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default ErrorPlaceholder;
